<template>
  <header class="course-header d-flex align-items-center" role="banner">
    <!-- TITLE PAGE -->
    <div class="container course-header__branding">
      <div class="course-header__title">
        <h1 class="course-title"><slot>CAC Title</slot></h1>
        <img src="@/assets/img/_branding/rca_leaf_logo.svg" class="d-block m-auto pt-4" alt="RCA umpire logo">
      </div>
      <div class="course-header__chevron-icon">
      <!-- <img
        src="@/assets/img/_nav/down-chevron.png"
        class="img-fluid animated infinite bounce delay-5s"
        alt="Scroll down to proceed"
      /> -->
    </div>
    </div>
  </header>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
  $red: #EB213A;
  /**
  * CAC Banner
  */
  .course-header {
    background: url('../../assets/img/_landing-page/rca-rowing-safety-landing-page-mbl.png') no-repeat;
    background-size: cover;
    // padding: 60% 5% 40% 5%;
    width: 100%;
    min-height: 40rem;
    height: 92vh;
    position: relative;
    color: $red;

    // ELEMENTS
    &__branding {
      margin-top: 5rem;
    }

    &__title {
      margin: auto;
      img {
          margin-bottom: 40px
      }
      h1 {
          text-transform: uppercase;
          // color: $drkBlueGrey;
          text-align: center;
          width: fit-content;
          font-weight: 700;
          margin: 2rem auto;
          font-size: 3rem
      }
    }

    &__bottom-logo {
      display: block;
      margin: auto;
    }

    &__chevron-icon {
      position: absolute;
      // width: 100%;
      left: calc(50% - 10px);
      display: block;
      margin: auto;
      bottom: 15px;

      img {
        margin: auto;
        display: block;
        // width: 30px;
      }
    }
  }

  /*------------------------------------*\
    #MEDIA SCREENS > 767px (TABLETS)
  \*------------------------------------*/
  @media (min-width:767px) {
     /**
      * CAC Banner
      */
      .course-header {
        background: url('../../assets/img/_landing-page/rca-rowing-safety-landing-page-dsk.png') no-repeat;
        background-size: cover;

        // ELS
        &__branding {
          margin-top: 20rem;
        }

        &__title {
          // margin-top: 10rem;
          h1 {
            margin: auto;
            text-align: left;
            font-size: 4rem;
          }

          img {
            width: 150px;
          }
        }

        &__bottom-logo {
          margin: 3rem auto;
        }
      }
    }

  /*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
  @media (min-width:992px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1200px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1320px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1600px) {

  }
</style>
